/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Sweet_FreshInputs */

const en_coach_sweet_fresh = /** @type {(inputs: Coach_Sweet_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are well-rested and your fitness is high relative to your fatigue. This is the ideal state for racing or key workouts. If you have a target event coming up, now is the time to perform.`)
};

const de_coach_sweet_fresh = /** @type {(inputs: Coach_Sweet_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gut erholt, Fitness hoch im Verhältnis zur Ermüdung. Idealer Zustand für Wettkämpfe oder Schlüsseleinheiten. Wenn ein Event ansteht — jetzt ist dein Moment.`)
};

/**
* | output |
* | --- |
* | "You are well-rested and your fitness is high relative to your fatigue. This is the ideal state for racing or key workouts. If you have a target event coming ..." |
*
* @param {Coach_Sweet_FreshInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_sweet_fresh = /** @type {((inputs?: Coach_Sweet_FreshInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Sweet_FreshInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_sweet_fresh(inputs)
	return de_coach_sweet_fresh(inputs)
});